"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedVector3 = void 0;
const Vector3_1 = require("../ValueObjects/Vector3");
class MemoizedVector3 {
    constructor(initialValue, onChangeCallback) {
        this._val = initialValue;
        this.onChangeCallback = onChangeCallback;
    }
    get val() {
        return this._val;
    }
    set val(v) {
        if (Vector3_1.Vector3.Equal(v, this._val))
            return;
        this._val = v;
        this.onChangeCallback();
    }
    setValQuietly(val) {
        this._val = val;
    }
}
exports.MemoizedVector3 = MemoizedVector3;
